import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

import Image, { getImageKey } from '../../../atoms/Image/Image';
import { GatsbyImagePropType } from '../../../services/proptypes';

const ImageRow = ({ imageGroup }) => {
  return (
    <Grid.Row columns={imageGroup.length} style={{ padding: '0' }}>
      {imageGroup.map(image => (
        <Grid.Column key={getImageKey(image)} style={{ padding: '0.3em' }}>
          <Image background imageQuery={image} src={image} style={{ paddingTop: '100%' }} />
        </Grid.Column>
      ))}
    </Grid.Row>
  );
};

export default ImageRow;

ImageRow.propTypes = {
  imageGroup: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(GatsbyImagePropType),
  ]).isRequired,
};
